import {
    buildConfigSlice,
    useConfigSlice,
    WidgetConfigSliceActionPayloadType,
} from 'widgets/store/configuration/configSlice';
import {
    initialVenueAnalysisConfigurationState,
    VenueAnalysisConfigurationState,
} from './VenueAnalysisConfigurationState';
import { WidgetType } from 'widgets/WidgetType';
import { selectVenueAnalysisState } from '../selectors';

export const buildVenueAnalysisConfigSlice = () =>
    buildConfigSlice<VenueAnalysisConfigurationState>(
        WidgetType.VENUE_ANALYSIS,
        selectVenueAnalysisState,
        initialVenueAnalysisConfigurationState,
        upgradeConfig
    );

export const useVenueAnalysisConfigSlice = () =>
    useConfigSlice(buildVenueAnalysisConfigSlice());

export type VenueAnalysisConfigPayloadType =
    WidgetConfigSliceActionPayloadType<VenueAnalysisConfigurationState>;

function upgradeConfig(
    config: VenueAnalysisConfigurationState | undefined
): VenueAnalysisConfigurationState {
    const ret = config || initialVenueAnalysisConfigurationState;
    if (ret.avgPriceDecimals === undefined) {
        ret.avgPriceDecimals =
            initialVenueAnalysisConfigurationState.avgPriceDecimals;
    }
    return ret;
}
